import { FC, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import Step1 from './components/Step1'
import Step2 from './components/Step2'

import { CreateAdSpotFormDataProvider } from 'contexts/CreateAdSpotFormContext'

export const CreateAdSpotModal: FC = () => {
  const [activePage, setActivePage] = useState(0)
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const onHide = () => {
    navigate(`../?${searchParams}`, { replace: true })
  }

  return (
    <CreateAdSpotFormDataProvider>
      {activePage === 0 && <Step1 onHide={onHide} setActivePage={() => setActivePage((prev) => prev + 1)} />}
      {activePage === 1 && <Step2 onHide={onHide} />}
    </CreateAdSpotFormDataProvider>
  )
}


